<template>

  <DoubleColumnLayout>

    <v-container>

        <!-- Kalkules WP Top Banner -->
        <ConditionalAdsense
          data-ad-client="ca-pub-1338414232761221"
          data-ad-slot="3661147294"
          data-ad-format="auto"
          data-full-width-responsive="true"
        >
        </ConditionalAdsense>

      <h1>{{ $t('online.percentageCalculator.metaTitle') }}</h1>
      <percentage-calculator />

    </v-container>

    <template v-slot:right>
      <AppList />
    </template>

  </DoubleColumnLayout>

</template>

<script>

import AppList from "@/components/AppList.vue";
import ConditionalAdsense from "@/components/ConditionalAdsense.vue";
import PercentageCalculator from "@/components/calculators/PercentageCalculator.vue";
import DoubleColumnLayout from "@/components/DoubleColumnLayout.vue";

export default {
  name: "PercentageCalculatorView",
  components: {
    AppList,
    ConditionalAdsense,
    PercentageCalculator,
    DoubleColumnLayout,
  },
  metaInfo() {
    return {
      title: this.$t('online.percentageCalculator.metaTitle'),
      meta: [
        { property: "og:title", content: this.$t('online.percentageCalculator.metaTitle') },
        { property: "og:description", content: this.$t('online.percentageCalculator.metaDescription') },
        { name: "twitter:title", content: this.$t('online.percentageCalculator.metaTitle') },
        { name: "twitter:description", content: this.$t('online.percentageCalculator.metaDescription') },
        { itemprop: "name", content: this.$t('online.percentageCalculator.metaTitle') },
        { itemprop: "description", content: this.$t('online.percentageCalculator.metaDescription') },
      ],
    };
  },
};

</script>